import axios from "axios";

const adminApi = axios.create({
 baseURL: "https://ecommerce-platform-two-olive.vercel.app/api",
// baseURL: "http://localhost:5000/api",
});

adminApi.interceptors.request.use((req) => {
  const token = localStorage.getItem("adminToken");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export default adminApi;
